module.exports = __webpack_public_path__ + "img/done.a6b1924a.svg";